import React, { useEffect, ComponentProps } from 'react';
import { useAuthentication } from '../../../v2/LoginPageV2';
import { ApplicationEntrySidebar } from './ApplicationEntrySidebar';
import { ApplicationEntrySaveAndExitButton } from './ApplicationEntrySaveAndExitButton';
import { ApplicationEntryNavigationButtons } from './ApplicationEntryNavigationButtons';
import { ProgressBreadcrumb, Button } from '@apply/components';

type ProgressBreadcrumbProps = ComponentProps<typeof ProgressBreadcrumb>;
type ButtonProps = ComponentProps<typeof Button>;
export interface ApplicationEntryPanelV2Props {
    children: any;
    sections: ProgressBreadcrumbProps[];
    currentSection: number;
    printMode?: boolean;
    saveAndExitButtonProps: ButtonProps;
    nextStepButtonProps: ButtonProps;
    previousStepButtonVisible?: boolean;
}

export const ApplicationEntryPanel: React.FC<ApplicationEntryPanelV2Props> = ({
    children,
    sections,
    currentSection,
    printMode,
    saveAndExitButtonProps,
    nextStepButtonProps,
    previousStepButtonVisible,
}) => {
    const { authentication, isAuthenticated } = useAuthentication();

    useEffect(() => {
        if (!authentication) {
            return;
        }

        if (!isAuthenticated) {
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
    }, [authentication, isAuthenticated]);

    return (
        <>
            <div className='applicationEntry-nonMobile'>
                <div className='applicationEntry-left'>
                    <ApplicationEntrySidebar
                        crumbs={sections}
                        currentCrumb={currentSection}
                    />
                </div>
                <div className='applicationEntry-right'>
                    <div className='applicationEntry-appWrapper'>
                        <div className='applicationEntry-appWrapper-saveAndExitButtons'>
                            <ApplicationEntrySaveAndExitButton saveAndExitButtonProps={saveAndExitButtonProps} />
                        </div>
                        <div className='applicationEntry-appWrapper-content'>{children}</div>
                        <div className='applicationEntry-appWrapper-navigationButtons'>
                            <ApplicationEntryNavigationButtons
                                nextStepButtonProps={nextStepButtonProps}
                                previousStepButtonVisible={previousStepButtonVisible}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
